import { defineMessages } from 'react-intl';

import { ContentSections } from '../../../constants/ContentSections';

export const messages = defineMessages({
  followOnTwitter: {
    id: 't.followOnTwitter',
    defaultMessage: 'Follow On Twitter',
  },
});

export const Actions = Object.freeze({
  ENTER_BACKSTAGE: 'ENTER_BACKSTAGE',
  LEAVE_BACKSTAGE: 'LEAVE_BACKSTAGE',
} as const);

export const Keys = Object.freeze({
  CURRENT_ROUTE: 'currentRoute',
} as const);

export const BackstageLoggerDefaultArgs = Object.freeze({
  artistRadio: {
    contentSection: ContentSections.ARTIST_RADIO,
  },
  artistsOnStation: {
    contentSection: ContentSections.ARTISTS_ON_STATION,
  },
  controlBar: {
    contentSection: ContentSections.CONTROL_BAR,
  },
  copyright: {
    contentSection: ContentSections.COPYRIGHT,
  },
  credits: {
    contentSection: ContentSections.CREDITS,
  },
  description: {
    contentSection: ContentSections.DESCRIPTION,
  },
  header: {
    contentSection: ContentSections.HEADER,
  },
  latestRelease: {
    contentSection: ContentSections.LATEST_RELEASE,
  },
  lyrics: {
    contentSection: ContentSections.LYRICS,
  },
  similarArtists: {
    contentSection: ContentSections.SIMILAR_ARTISTS,
  },
  similarSongs: {
    contentSection: ContentSections.SIMILAR_SONGS,
  },
  songFeatures: {
    contentSection: ContentSections.SONG_FEATURES,
  },
  songsOnStation: {
    contentSection: ContentSections.SONGS_ON_STATION,
  },
  topAlbums: {
    contentSection: ContentSections.TOP_ALBUMS,
  },
  topSongs: {
    contentSection: ContentSections.TOP_SONGS,
  },
  trackList: {
    contentSection: ContentSections.TRACK_LIST,
  },
} as const);
